// Each division's icon, one per icon key. The chemical-plant icon is
// already full-color; the rest are black glyphs recolored to white via CSS
// (see img.division-split-icon in Divisions.css) wherever they're used on
// a dark background.
const iconSrc = {
  match: '/images/icons/matches.png',
  firework: '/images/icons/dynamite.png',
  flask: '/images/icons/chemical-plant.png',
  printer: '/images/icons/printing-press.png',
  pharmacy: '/images/icons/graduation-cap.png',
  truck: '/images/icons/container-truck.png',
  plant: '/images/icons/soil.png',
  school: '/images/icons/school.png',
};

const icons = Object.fromEntries(
  Object.entries(iconSrc).map(([key, src]) => [
    key,
    function DivisionIcon({ className = '', ...rest }) {
      const fullColor = key === 'flask' ? ' division-icon-full-color' : '';
      // The printing-press artwork is a wide ~2.25:1 illustration rather
      // than a square glyph, so it opts out of the square icon box.
      const wide = key === 'printer' ? ' division-icon-wide' : '';
      return <img src={src} alt="" className={`${className}${fullColor}${wide}`} {...rest} />;
    },
  ])
);

export default icons;
